 <template>
  <div>
 <el-dialog title="售后服务" :visible="ideavisi" customClass="way aftersolt" :append-to-body="true"  :befor-close="idevisi"  @close='idevisi'>
<el-form ref="form" :model="form">
  <el-form-item >
    <label>意见反馈标题</label>
    <el-input v-model="form.name"></el-input>
  </el-form-item>
  <el-form-item>
    <label>意见反馈内容</label>
    <el-input type="textarea" v-model="form.desc"></el-input>
  </el-form-item>
 
</el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="idevisi()">关闭</el-button>
      <el-button type="primary" @click="idevisi()">确 定</el-button>
    </span>
  </el-dialog>
  </div>
</template>
<script>

export default {
  props:{
    ideavisi:{  type: [Boolean], default: false }
  },
   data() {
    return {
   form: {
          name: '',
          desc: ''
        }
    };
  },
  created() {
  
  },
 
  methods: {
    idevisi(){
      this.$emit("idvisi")
    }
  },
};
</script>
